import {apiVoissa} from "../../libs/api";
import qs from "qs";

export const fetchLastTopics = (config = {}) => apiVoissa.get(`/topics/last`, config);
export const fetchTopic = (topicId, query = {}, config = {}) => apiVoissa.get(`/topics/${topicId}?${qs.stringify(query)}`, config);

export const createForumTopic = (forumId = null, data = {}, config = {}) => apiVoissa.post(`/forums/${forumId}/topics`, data, config);
export const updateForumTopic = (forumId = null, topicId, data = {}, config = {}) => apiVoissa.patch(`/forums/${forumId}/topics/${topicId}`, data, config);
export const moveForumTopic = (forumId = null, topicId = null, data = {}, config = {}) => apiVoissa.patch(`/forums/${forumId}/topics/${topicId}/move`, data, config);
export const deleteForumTopic = (forumId = null, topicId = {}, config = {}) => apiVoissa.delete(`/forums/${forumId}/topics/${topicId}`, config);

export const setCountViewTopic = (id, config = {}) => apiVoissa.patch(`/topics/${id}/view`, '', config);

export const reportTopic = (id, data = {}, config = {}) => apiVoissa.post(`/topics/${id}/reporting`, data, config);

export const fetchTopicsForDating = (query = {}, config = {}) => {
    if(query.sortBy){
        query.sort = query.sortBy;
        delete query.sortBy;
    }
    return apiVoissa.get(`/topics?${qs.stringify(query)}`, config)
};

export const TOPICS_LAST_KEY = `topics-last`;
export const TOPICS_DATING_KEY = `topics-dating`;
export const TOPIC_KEY = `topic`;

export const TOPIC_SET_COUNT_VIEW_KEY = `topic-sex-count-view`;